import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    $(document).ready(function () {
        var selector = ".chapter-title";
        if (!$(selector).length) return;

        jdmn.log("custom_chapter-title.js initialized", "green");
        gsap.registerPlugin(ScrollTrigger);

        $(selector).each(function () {
            var $instance = $(this);
            var $maskSection = $instance.find(".mask-section");
            var $overlay = $instance.find(".overlay");
            var $titleStrip = $maskSection.find(".head-xl");

            gsap.to($maskSection[0], {
                maskSize: "350vmax",
                ease: "none",
                scrollTrigger: {
                    scroller: window,
                    trigger: $instance[0],
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 1,
                },
            });

            gsap.to($overlay[0], {
                alpha: 0,
                ease: "none",
                scrollTrigger: {
                    scroller: window,
                    trigger: $instance[0],
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 1,
                },
            });

            gsap.to($titleStrip[0], {
                scale: 2,
                ease: "none",
                scrollTrigger: {
                    scroller: window,
                    trigger: $instance[0],
                    start: "bottom bottom",
                    end: "bottom top",
                    scrub: 1,
                },
            });
        });
    });
})();
